<template>
    <div
        class="inner"
        :class="{ 'sp-image-height': heightStyle }"
        style="position: relative; over-flow: hidden"
        :style="'background-color:' + backgroundColor + ';'"
    >
        <blog-background-image
            :image-url="
                state.currentImage?.filename
                    ? buildImageUrl(state.currentImage?.filename)
                    : ''
            "
            :selected-image="state.uploadedImage"
            :is-visible-image-dom="isSpecifiedImage"
            :image-position="state.currentImage?.position"
            :is-visible-location-setting="isVisible.locationSetting"
            :range-size="rangeSize"
            :ratio="state.ratio"
            :is-loading-image="isLoadingImage"
            :image-size="imageSize"
            @update-location="updatePosition"
        />
        <div id="title" v-if="!isSpecifiedImage">
            <h1>YouTuberChannel</h1>
        </div>
        <div v-if="isAccessedByMyself && !isSmartphoneLayout">
            <button
                id="ybh-setimgbt"
                class="hover-setting1 blog-button"
                title="設定画面へ移動する！"
                type="button"
                @click="onClickEdit"
                v-if="!isVisible.locationSetting"
            >
                編集
            </button>
            <blog-background-menu
                :is-visible="isVisible.menu"
                :image-filename="state.originalImage.filename"
                @open:file-chooser="onClickOpenFileChooser"
                @delete:image="onClickDelete"
                @change:position="onClickChangePosition"
                @close="onClickCancel"
            />
            <div id="ybh-imgSet-buttons">
                <div v-if="isVisible.locationSetting">
                    <button
                        type="button"
                        class="hover-setting1 blog-button"
                        title="設定する"
                        :disabled="isUploading"
                        @click="onClickUploadImage()"
                    >
                        <a>設定</a>
                    </button>
                    <button
                        type="button"
                        @click="onClickRollback()"
                        name="img_cancel"
                        class="hover-setting1 blog-button"
                        title="元に戻す"
                        :disabled="isUploading"
                    >
                        元に戻す
                    </button>
                </div>
                <input
                    ref="fileUploader"
                    type="file"
                    class="hidden"
                    accept="image/jpeg,image/png,image/gif"
                    name="image"
                    id="ybh-backimg-file"
                    @change="loadImage"
                />
                <input
                    type="text"
                    class="hidden"
                    name="image_position"
                    :value="state.currentImage.position"
                />
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import {
    onBeforeUpdate,
    onMounted,
    onUpdated,
    computed,
    reactive,
    inject
} from "vue";
import { ref, defineComponent } from "vue";
import BlogBackgroundImage from "./BlogBackgroundImage.vue";
import BlogBackgroundMenu from "./BlogBackgroundMenu.vue";

export default defineComponent({
    props: {
        isAccessedByMyself: Boolean,
        originalPosition: String,
        originalFilename: String,
        uniqueId: String,
        csrf: String,
        isMobile: Boolean,
        domain: String,
    },
    components: {
        BlogBackgroundImage,
        BlogBackgroundMenu,
    },
    setup(props, context) {
        const store = inject("store");
        store.setRatio();
        const state = computed(() => {
            return store.state;
        });
        const idMobile = ref(false);
        const isChangingPosition = ref(false);
        const isVisible = reactive({
            menu: false,
            locationSetting: false,
        });
        const isUploading = ref(false);
        const isLoadingImage = ref(false);
        const isMovingImage = ref(false);
        const fileUploader = ref();
        const rangeSize = computed(() => {
            return store.state.rangeSize;
        });
        const imageSize = computed(() => {
            return store.state.currentImage.size;
        })
        onMounted(() => {
            if (props.isMobile) {
                store.setRatio();
            }
            store.setRatio();
            // unique id を設定
            store.setUniqueId(props.uniqueId);
            store.setCsrfToken(props.csrf);
            window.addEventListener('resize', resize);

            if (props.originalFilename) {
                // 登録情報を設定
                store.setOriginal(
                    props.originalFilename,
                    props.originalPosition
                );
                store.setCurrent(
                    props.originalFilename,
                    props.originalPosition
                );

                var image = new Image();
                image.onload = function () {
                    isLoadingImage.value = false;
                    // $("#img_loading").fadeOut("slow");
                    store.setOriginalImageSize(
                        image.naturalWidth,
                        image.naturalHeight
                    );
                    store.setImageSize(image.naturalWidth, image.naturalHeight);


                    let color = calcAverageColor(image);
                    store.setBackgroundColor(color);
                    store.setOriginalBackgroundColor(color);
                };
                isLoadingImage.value = true;
                // $("#img_loading").fadeIn("slow");
                image.src = buildImageUrl(props.originalFilename);
            } else {
                store.setBackgroundColor("#58BE89");
            }
        });
        const buildImageUrl = (filename) => {
            return props.domain + "/storage/" + props.uniqueId + "/" + filename;
        };
        const isSpecifiedImage = computed(() => {
            return !!store.uploadedImage() || !!store.currentImage()?.filename;
        });

        const updatePosition = (position) => {
            store.setCurrentPosition(position);
        };

        /**
         * window size 変更を検知して store にwindow size を記録する。
         */
        const resize = () => {
            store.setWindowSize();
            store.setRatio();
        }

        const onClickEdit = () => {
            isVisible.menu = true;
        };

        const onClickCancel = () => {
            isVisible.menu = false;
        };
        const onClickDelete = () => {
            if (!confirm("削除してよろしいですか？")) {
                return;
            }
            store
                .deleteImage()
                .then(() => {
                    toastInstance.$toast.success("削除しました。");
                    document.querySelector("#ybh-backimg-file").value = "";
                    store.clearAll();
                })
                .catch(() => {
                    toastInstance.$toast.error("削除に失敗ました。");
                });
        };

        const setInitialState = () => {
            store.setBackgroundColor("#58be89");
            isVisible.locationSetting = false;
            isVisible.menu = false;

            store.setOriginal(null, "top 0px left 0px");
            store.setCurrent(null, "top 0px left 0px");
        };

        const onClickRollback = () => {
            if (!confirm("元の設定に戻します。よろしいですか？")) {
                return;
            }
            store.rollbackToOriginal();
            // もともと画像が設定していない場合
            if (!store.currentImage().filename) {
                setInitialState();
                return;
            }
            document.querySelector("#ybh-backimg-file").value = "";
            isVisible.locationSetting = false;
        };
        const onClickChangePosition = () => {
            isVisible.menu = false;
            isVisible.locationSetting = true;
        };
        const onClickUploadImage = () => {
            store
                .uploadImage()
                .then((response) => {
                    isVisible.menu = false;
                    isVisible.locationSetting = false;

                    // 初期値を変更
                    if (response.data.filename) {
                        store.setOriginal(
                            response.data.filename,
                            response.data.position
                        );
                        store.setCurrent(
                            response.data.filename,
                            response.data.position
                        );
                    } else {
                        store.setPosition(response.data.position);
                    }
                    store.copyCurrentToOriginal();
                    // Toast
                    toastInstance.$toast.success("変更しました！");
                })
                .catch((response) => {
                    console.error(response);
                    // Toast
                    toastInstance.$toast.error("変更に失敗しました！");
                })
                .finally(() => {
                    isUploading.value = false;
                });
        };

        const loadImage = (event) => {
            if (!event.target.files.length) return; // ファイル未選択
            const file = event.target.files[0];

            //拡張子をチェックします。
            if (!/^image\/(png|jpg|jpeg|gif)$/.test(file.type)) {
                alert("拡張子が対応していません。");
                return;
            }

            //ファイルサイズチェックを行います。
            const mbSize = file.size / 1024 / 1024;
            if (mbSize > 3) {
                // TODO: $("#ybh-backimg-file").val(""); //選択クリア
                alert(
                    "ファイルサイズが大きすぎます。" +
                        "\n 3MBまでUpload可能です。"
                );
                return;
            }

            // read file
            const fileReader = new FileReader();
            fileReader.onloadend = function () {
                // チェック縦横サイズ
                const image = new Image();
                image.onload = function () {
                    if (
                        image.naturalWidth < 1024 ||
                        image.naturalHeight < 600
                    ) {
                        alert(
                            "画像サイズが小さいです。1024px × 600px以上の画像を指定してください。"
                        );
                        isLoadingImage.value = false;
                        return;
                    }
                    store.setImageSize(image.naturalWidth, image.naturalHeight);
                    // store.setRangeSize(
                    // image.naturalWidth - outerWidth.value;
                    // image.naturalHeight - outerHeight.value;

                    // rangeSize.width = image.naturalWidth - outerWidth.value;
                    // rangeSize.height = image.naturalHeight - outerHeight.value;
                    // ポップアップ閉じる
                    isVisible.menu = false;
                    // 位置情報設定ボタンを表示
                    isVisible.locationSetting = true;

                    // 背景色を画像の平均色に変更
                    store.setBackgroundColor(calcAverageColor(image));
                    store.setSelectedImage(image.src);
                    store.setSelectedFile(file);

                    isLoadingImage.value = false;
                };
                isLoadingImage.value = true;
                image.src = fileReader.result;
            };
            fileReader.readAsDataURL(file);
        };

        const backgroundColor = computed(() => {
            return store.currentImage().backgroundColor;
        });

        const onClickOpenFileChooser = () => {
            fileUploader.value.click();
        };

        const calcAverageColor = (image) => {
            const canvas = document.createElement("canvas");
            const style = canvas.style;

            style.width = image.width + "px";
            style.height = image.height + "px";

            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const data = ctx.getImageData(0, 0, canvas.width, canvas.height);

            let tmp = 0;
            let R = 0;
            let G = 0;
            let B = 0;
            let A = 0;
            let num = data.height * data.width;

            for (var i = 0; i < data.height; i++) {
                for (var j = 0; j < data.width; j++) {
                    tmp = i * (data.width * 4) + j * 4;
                    R += data.data[tmp + 0];
                    G += data.data[tmp + 1];
                    B += data.data[tmp + 2];
                    A += data.data[tmp + 3];
                }
            }
            return rgb2hex([
                Math.round(R / num),
                Math.round(G / num),
                Math.round(B / num),
            ]);
        };
        const heightStyle = computed(() => {
            return (store.state.windowSize.width < 750 && (store.state.currentImage?.filename || store.state.uploadedImage)) ;
        });
        const isSmartphoneLayout = computed(() => {
            return store.state.windowSize.width < 750;
        });
        return {
            isVisible,
            isUploading,
            isLoadingImage,
            isMovingImage,
            isSpecifiedImage,
            loadImage,
            onClickEdit,
            onClickCancel,
            onClickDelete,
            onClickRollback,
            onClickUploadImage,
            onClickChangePosition,
            updatePosition,
            onClickOpenFileChooser,
            fileUploader,
            buildImageUrl,
            state,
            store,
            rangeSize,
            backgroundColor,
            heightStyle,
            isSmartphoneLayout,
            imageSize,
            resize
        };
    },
});
</script>

<style lang="scss" scoped>
.disabled {
    opacity: 0.4;
}

#header .sp-image-height {
    height: calc(100vw * 600 / 1024 );
}
</style>
